
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

@Options( {
  components : {
    Header : defineAsyncComponent( () => import("@/components/Header.vue") ),
    Footer : defineAsyncComponent( () => import("@/components/Footer.vue") )
  }
} )
export default class extends Vue
{
  store = useStore( key );

  meta = setup( () => useMeta( {
    title : [{
      content : "Augmenter la visibilité de vos box sur internet",
      vmid    : "title",
      name    : "title"
    }],
    description : {
      content : "Laissez-nous commercialiser votre garde-meuble ou votre self stockage gratuitement. Profitez de notre outil marketing unique !",
      vmid    : "description",
      name    : "description"
    }
  } ) );

  success = false;
  loading = false;
  modal   = false;
  error   = "";

  articles = [
    {
      id     : 1,
      author : "Gilles Tremblaye",
      title  : "Témoignage de Gilles Tremblaye du site Okbox.fr",
      gm     : "Okbox.fr",
      text   : "« Grâce à notre partenariat avec le site Location-gardemeuble.fr, depuis juillet 2013, nous avons la possibilité de faire connaître nos établissements sur le territoire national et ça marche ! Notre centre de Chartres a été rempli en moins de 12 mois et nous avons pu lancer une extension du nombre de box »",
      gm_id  : 552
    },
    {
      id     : 2,
      author : "Vincent Boucher",
      title  : "Témoignage de Vincent Boucher du garde meuble 1 Box en Plus Nantes",
      gm     : "1 Box en Plus Nantes",
      text   : "« Pour réussir mon ouverture, j’ai collaboré avec le site Location-gardemeuble.fr En 2 mois, j’ai loué 51 box de self stockage ! »",
      gm_id  : 501
    },
    {
      id     : 3,
      author : "Lucien Blondeau",
      title  : "Témoignage de Lucien Blondeau du garde meuble StockBox66",
      gm     : "StockBox66",
      text   : "« Pour mon premier centre de self stockage en containers, je me suis inscrit sur Location-gardemeuble.fr. Cela m’apporte réellement des clients. Depuis 15 mois, j’ai un taux de remplissage de plus de 90% et j’ai ouvert depuis un deuxième centre ».",
      gm_id  : 493
    },
    {
      id     : 4,
      author : "Alain Fournier",
      title  : "Témoignage de Alain Fournier du garde meuble Self Stock",
      gm     : "Self Stock",
      text   : "« En 4 ans de collaboration, je remarque que les équipes du site Location-gardemeuble.fr se préoccupent à la fois des clients et des partenaires. Le site est un réel apporteur d’affaires. Je peux développer sereinement ma marque. Lors de mon inscription, j’avais 1 établissement. Aujourd’hui, je dispose de 4 centres et prévoit encore 4 nouvelles ouvertures ! »",
      gm_id  : 515
    }
  ];

  formData = {
    name  : "",
    owner : "",
    email : "",
    phone : ""
  };

  submit( evt : any )
  {
    // Prevent double submit
    if( this.success || this.loading )
      return;

    this.loading = true;
    this.error   = "";

    let request = fetch( this.store.state.api + "adhesion", {
      method  : "POST",
      cache   : "no-cache",
      headers : {
        "Content-Type" : "application/json",
        "Accept"       : "application/json"
      },
      body    : JSON.stringify( this.formData )
    } );

    request.then( ( res ) => { return res.json(); } ).then( this.ajaxSuccess );
    request.catch( this.ajaxError );
  }

  ajaxSuccess( response : any )
  {
    if( response.data.success )
    {
      this.success = true;
      this.loading = false;
      this.error   = response.data.message;
    } else
    {
      this.ajaxError( response );
    }
  }

  ajaxError( response : any )
  {
    this.success = false;
    this.loading = false;

    if( response.data )
    {
      if( response.data.errors )
        this.error = response.data.errors.join( "<br>" );
      else if( response.data.message )
        this.error = response.data.message;
    } else
    {
      this.error = "Une erreur est survenue";
    }
  }

  mounted()
  {
    setTimeout( () => {
      this.store.state.loading = false;

      // Remove div#preload from DOM
      let preload = document.getElementById( "preload" );
      if( preload )
      {
        window.scrollTo( { top : 0 } );
        preload.remove();
      }
    }, this.store.state.delay );  }
}
